/* globals SmoothScroll, Vue, $ */
import './bootstrap_for_ie';

import 'easy-autocomplete/dist/jquery.easy-autocomplete.js';